import React, { useContext, useEffect, useState } from 'react';
import { assets } from '../assets/assets';
import VideoCollection from '../components/VideoCollection';
import { CiSearch } from "react-icons/ci";
import ProductItem from '../components/ProductItem';
import { ShopContext } from '../context/ShopContext';
import { IoIosArrowDown } from "react-icons/io";



const DonateMonthly = () => {
  const { products } = useContext(ShopContext);
  const [filterProducts, setFilterProducts] = useState([]);
  const [activeCategory, setActiveCategory] = useState('All');
  const [searchTerm, setSearchTerm] = useState(''); // Add state for search term
  const [showFilter, SetShowFilter] = useState(false);

  useEffect(() => {
    handleFiltering(); // Call filtering logic on initial load and whenever products change
  }, [products, activeCategory, searchTerm]);

  // Filter logic based on category and search term
  const handleFiltering = () => {
    let filtered = products;

        // Filter by type first to ensure only one-time products are included
        filtered = filtered.filter(product => product.type === 'monthly');

    // Filter by category
    if (activeCategory !== 'All') {
      filtered = filtered.filter(product => product.category === activeCategory);
    }

    // Filter by search term
    if (searchTerm) {
      filtered = filtered.filter(product =>
        product.title.toLowerCase().includes(searchTerm.toLowerCase())
      );
    }

    setFilterProducts(filtered);
  };

  // Handle category click
  const handleCategoryClick = (category) => {
    setActiveCategory(category);
  };

  // Handle search input change
  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };

 // Handle form submit to prevent default behavior
 const handleSearchSubmit = (e) => {
  e.preventDefault(); // Prevent page reload on form submit
  handleFiltering(); // Call filtering logic explicitly (optional, since useEffect already handles it)
};
  return (
    <div>
    {/* ======================= Banner Start ============================ */}
    <div className="banner_sec donate_banner" style={{ backgroundImage: `url(${assets.monthly_banner})` }}>
  <div className="container">
    <div className="content text-center text-sm-start">
      <h1 className="title text-white">
        Donate Monthly
      </h1>
      <p className="subtitle text-white">From poverty and injustice</p>
      <div className="ps-xl-5 ms-xl-5 common-section-sd d-sm-block">
        <a
          href="#"
          className="banner_btn mt-3 mt-sm-5 d-inline-block px-5 bg-white py-2 text-uppercase d-inline-block rounded-pill"
          data-bs-toggle="modal"
          data-bs-target="#donationModal"
        >
          Donate Now
        </a>
      </div>
    </div>
  </div>
</div>


    {/* ======================= Banner End ============================ */}
    <VideoCollection />

    {/* Product Filter Section */}
    <div className="product-filter">
      <div className="container">
        <div className="row">
          {/* Filter Sidebar */}
          <div className="col-lg-3 col-md-3 col-sm-12">
            <div className="filter-section-area">
              <div onClick={()=>SetShowFilter(!showFilter)} className="div-flex">
              <h3>Categories</h3> < IoIosArrowDown className={`${showFilter ? 'rotate-icon' : ''}`}/>
              </div>
              <div className={`filter-content ${showFilter ? '' : 'hide'}`}> 
                <ul>
                  <li 
                    className={`filter-item monthly_donation_sec ${activeCategory === 'All' ? 'active' : ''}`} 
                    onClick={() => handleCategoryClick('All')}
                  >
                    <div className="icon">
                      <img src={assets.all_products_icon} className="img-fluid" alt="" />
                    </div>
                    <div className="category_name"><p>All</p></div>
                  </li>
                  <li 
                    className={`filter-item monthly_donation_sec ${activeCategory === 'urgent' ? 'active' : ''}`} 
                    onClick={() => handleCategoryClick('urgent')}
                  >
                    <div className="icon">
                      <img src={assets.filter_urgent_icon} className="img-fluid" alt="" />
                    </div>
                    <div className="category_name"><p>Urgent</p></div>
                  </li>
                  <li 
                    className={`filter-item monthly_donation_sec ${activeCategory === 'event' ? 'active' : ''}`} 
                    onClick={() => handleCategoryClick('event')}
                  >
                    <div className="icon">
                      <img src={assets.filter_life_event_icon} className="img-fluid" alt="" />
                    </div>
                    <div className="category_name"><p>Life Event</p></div>
                  </li>
                  <li 
                    className={`filter-item monthly_donation_sec ${activeCategory === 'hunger' ? 'active' : ''}`} 
                    onClick={() => handleCategoryClick('hunger')}
                  >
                    <div className="icon">
                      <img src={assets.filter_humger_icon} className="img-fluid" alt="" />
                    </div>
                    <div className="category_name"><p>Hunger</p></div>
                  </li>
                  <li 
                    className={`filter-item monthly_donation_sec ${activeCategory === 'medicine' ? 'active' : ''}`} 
                    onClick={() => handleCategoryClick('medicine')}
                  >
                    <div className="icon">
                      <img src={assets.filter_medical_icon} className="img-fluid" alt="" />
                    </div>
                    <div className="category_name"><p>Medicine</p></div>
                  </li>
                  <li 
                    className={`filter-item monthly_donation_sec ${activeCategory === 'education' ? 'active' : ''}`} 
                    onClick={() => handleCategoryClick('education')}
                  >
                    <div className="icon">
                      <img src={assets.filter_education_icon} className="img-fluid" alt="" />
                    </div>
                    <div className="category_name"><p>Education</p></div>
                  </li>
                  <li 
                    className={`filter-item monthly_donation_sec ${activeCategory === 'animals' ? 'active' : ''}`} 
                    onClick={() => handleCategoryClick('animals')}
                  >
                    <div className="icon">
                      <img src={assets.filter_animal_icon} className="img-fluid" alt="" />
                    </div>
                    <div className="category_name"><p>Animals</p></div>
                  </li>
                  <li 
                    className={`filter-item monthly_donation_sec ${activeCategory === 'nature' ? 'active' : ''}`} 
                    onClick={() => handleCategoryClick('nature')}
                  >
                    <div className="icon">
                      <img src={assets.filter_nature_icon} className="img-fluid" alt="" />
                    </div>
                    <div className="category_name"><p>Nature</p></div>
                  </li>
                  <li 
                    className={`filter-item monthly_donation_sec ${activeCategory === 'children' ? 'active' : ''}`} 
                    onClick={() => handleCategoryClick('children')}
                  >
                    <div className="icon">
                      <img src={assets.filter_children_icon} className="img-fluid" alt="" />
                    </div>
                    <div className="category_name"><p>Children</p></div>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          {/* Product Listing */}
          <div className="col-lg-9 col-md-9 col-sm-12">
            <div className="product-filter-item">
              <div className="our_campaigns">
                <div className="search">
                  <form onSubmit={handleSearchSubmit}> {/* Prevent form submit */}
                    <div className="input-group">
                    <input 
                        type="text" 
                        name="search" 
                        className="form-control" 
                        required 
                        placeholder="Search for campaign" 
                        value={searchTerm} // Bind search term to input field
                        onChange={handleSearchChange} // Update search term on change
                      />
                      <button  className="input-group-text">
                        <CiSearch />
                      </button>
                    </div>
                  </form>
                </div>
              </div>

              <div className="product-filter-items">
                <div className="row">
                  {filterProducts.length > 0 ? (
                    filterProducts.map((item, index) => (
                      <ProductItem
                        key={index}
                        id={item.id}
                        image={item.image}
                        title={item.title}
                        hoursLeft={item.hoursLeft}
                        sponsors={item.sponsors}
                        taxBenefit={item.taxBenefit}
                        target={item.target}
                        left={item.left}
                        goal={item.goal}
                      />
                    ))
                  ) : (
                    <p>No products available for this category</p>
                  )}
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
    {/* <!-- ======================= donation platform start  ============================ --> */}
    <div className="donation_platform pt-5 pb-5 mb-4">
        <div className="container">
            <div className="heading mb-5 text-center">
                <h3>India’s Most Trusted Online Donation Platfrom</h3>
            </div>
            <div className="row gy-5">
                <div className="col-md-6 col-lg-4">
                    <div className="text-center">
                        <div className="icon mb-2">
                            <img src={assets.trusted_icon1} alt="Opt to donate monthly for our missions or NGO
                            programs and make an impact"/>
                        </div>
                        <div className="content">
                            <p>
                                Opt to donate monthly for our missions or NGO
                                programs and make an impact
                            </p>
                        </div>
                    </div>
                </div>
                <div className="col-md-6 col-lg-4">
                    <div className="text-center">
                        <div className="icon mb-2">
                            <img src={assets.trusted_icon2} alt=" Support crowdfunding campaigns with one-time
                            donations TAX"/>
                        </div>
                        <div className="content">
                            <p>
                                Support crowdfunding campaigns with one-time
                                donations TAX
                            </p>
                        </div>
                    </div>
                </div>
                <div className="col-md-6 col-lg-4">
                    <div className="text-center">
                        <div className="icon mb-2">
                            <img src={assets.trusted_icon3} alt="CSR and employee giving through
                            trusted NGOs"/>
                        </div>
                        <div className="content">
                            <p> CSR and employee giving through
                                trusted NGOs
                            </p>
                        </div>
                    </div>
                </div>
                <div className="col-md-6 col-lg-4">
                    <div className="text-center">
                        <div className="icon mb-2">
                            <img src={assets.trusted_icon4} alt="Pick from causes like education, children
                            livelihoods, etc"/>
                        </div>
                        <div className="content">
                            <p>
                                Pick from causes like education, children
                                livelihoods, etc
                            </p>
                        </div>
                    </div>
                </div>
                <div className="col-md-6 col-lg-4">
                    <div className="text-center">
                        <div className="icon mb-2">
                            <img src={assets.trusted_icon5} alt=" Eligible for tax benefit 100%"/>
                        </div>
                        <div className="content">
                            <p>
                                Eligible for tax benefit 100%
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    {/* <!-- ======================= donation platform end  ============================ --> */}
  </div>
  )
}

export default DonateMonthly
